import { Injectable } from '@angular/core';
import { EmojiModel } from './emoji.model';

@Injectable({
  providedIn: 'root'
})
export class EmojiHelperService {

  private currentEmojiList : Array<EmojiModel> = new Array<EmojiModel>();

  constructor() { 
    this.populateCurrentEmojis();
  }

  private populateCurrentEmojis(): void {
    this.currentEmojiList.push(...[
      { name: "smile", pin: "U+1F600"},
      { name: "ghost", pin: "U+1F47B"},
      { name: "wave", pin: "U+1F44B"},
      { name: "glasses", pin: "U+1F576"},
      { name: "crown", pin: "U+1F451"},
      { name: "zebra", pin: "U+1F993"},
      { name: "cat", pin: "U+1F431"},
      { name: "sunflower", pin: "U+1F33B"},
      { name: "rocket", pin: "U+1F680"},
      { name: "car", pin: "U+1F697"},
      { name: "lightning", pin: "U+26A1"},
      { name: "bulb", pin: "U+1F4A1"},
      { name: "alien", pin: "U+1F47D"},
      { name: "heart", pin: "U+1F49C"},
      { name: "trophy", pin: "U+1F3C6"},
      { name: "football", pin: "U+26BD"},
      { name: "eightball", pin: "U+1F3B1"},
      { name: "dice", pin: "U+1F3B2"},
      { name: "house", pin: "U+1F3E0"},
      { name: "tree", pin: "U+1F333"},
      { name: "pineapple", pin: "U+1F34D"},
      { name: "thumbs-up", pin: "U+1F44D"},
      { name: "fish", pin: "U+1F41F"},
      { name: "present", pin: "U+1F381"},
      { name: "laugh", pin: "U+1F923"},
      { name: "sleep", pin: "U+1F4A4"},
      { name: "coffee", pin: "U+2615"},
      { name: "earth", pin: "U+1F30D"}
    ])
  }

  public getEmojiPin(emoji: string): string {
    let index = this.currentEmojiList.findIndex(e => e.name == emoji);
    if (index != null) {
      return this.currentEmojiList[index].pin;
    } else {
      return "";
    }
  }

  public getEmojiClass(pin: string): string {
    let index = this.currentEmojiList.findIndex(e => e.pin == pin);
    if (index != null) {
      return this.currentEmojiList[index].name +"-emoji";
    } else {
      return "";
    }
  }
}
